import React from 'react';

import { Form } from 'antd';
import cn from 'classnames';

import { helper } from '@utils/index';

import { TYPE_MAP } from '../SelectTypeField';
import { FORM_KYYS } from '../useMain';
import { CalculatedValue } from './CalculatedValue';

import styles from './index.module.less';

const { Item } = Form;

interface SubmitFieldProps {
  className?: string;
}

export const calculateTotalAmount = (form) => {
  const amount = form.getFieldValue(FORM_KYYS.amount); // 单个金额 或 总金额
  const num = form.getFieldValue(FORM_KYYS.num); // 发放分数
  const assignType = form.getFieldValue(FORM_KYYS.assignType); // 幸运空投 或 普通空投
  let totalAmount = amount;
  if (assignType !== TYPE_MAP.FORTUNE) {
    totalAmount = amount * num; // 计算总金额
  }
  return totalAmount;
}

export const Affixation: React.FC<SubmitFieldProps> = (props) => {
  const { className } = props;
  return (
    <Item
      className={cn(className, styles.affixation)}
      shouldUpdate
    >
      {form => {
        const currency = form.getFieldValue(FORM_KYYS.currency); // 当前币种
        const precision = form.getFieldValue('precision'); // 精度
        const totalAmount = calculateTotalAmount(form);
        if (!!totalAmount && !!currency) {
          return (<div className={styles.info}>
            <span className={styles.totalAmount}>{helper.formatFixNumString(totalAmount, precision)}&nbsp;{currency}</span>
            <CalculatedValue className={cn(styles.value, 'DINPro')} coinCode={currency} total={totalAmount} />
          </div>)
        }
        return null
      }}
    </Item>
  )
}
